export interface NotarizationLifecycle {
  id?: string;
  notarizationCompletedAt?: string | Date | null;
  externalId?: string | null;
  userALink?: string | null;
  userBLink?: string | null;
  attorneyALink?: string | null;
  attorneyBLink?: string | null;
}

export const notarizationLifecycleSelect = {
  notarizationCompletedAt: true,
  externalId: true,
  userALink: true,
  userBLink: true,
  attorneyALink: true,
  attorneyBLink: true,
} as const;

export const isPendingManualNotarization = (
  notarization: NotarizationLifecycle,
): boolean =>
  notarization.notarizationCompletedAt === null &&
  notarization.externalId === null &&
  notarization.userALink === null &&
  notarization.userBLink === null &&
  notarization.attorneyALink === null &&
  notarization.attorneyBLink === null;
